import { Navigate, Outlet, useLocation } from 'react-router';

import { PantallaCarga } from '@/components/PantallaCarga';

import { useAuth } from './AuthProvider';

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <PantallaCarga />;
  if (status === 'anonymous')
    return <Navigate to="/login" replace state={{ desde: location.pathname }} />;
  return <Outlet />;
}

/** Rutas públicas (login, registro…): si ya hay sesión, al inicio. */
export function RedirectIfAuthenticated() {
  const { status } = useAuth();
  if (status === 'loading') return <PantallaCarga />;
  if (status === 'authenticated') return <Navigate to="/inicio" replace />;
  return <Outlet />;
}
